import { render } from "./ResponsiblingsList.vue?vue&type=template&id=d4fb57d8"
import script from "./ResponsiblingsList.vue?vue&type=script&lang=js"
export * from "./ResponsiblingsList.vue?vue&type=script&lang=js"

import "./ResponsiblingsList.vue?vue&type=style&index=0&id=d4fb57d8&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__